import React, { useEffect, useState } from "react";

import { PAGES_PATH } from "../../../navigation/params";
import { Typography } from "@mui/material";
import { useLogout } from "../../../services/user/user.service";
import { useNavigate } from "react-router-dom";

const UserDeleteModalRedirect = () => {
  const navigate = useNavigate();

  const [count, setCount] = useState(5);
  const { logout } = useLogout();

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count - 1);
    }, 1000);

    if (count === 0) {
      clearInterval(interval);
      logout(false);
      navigate(PAGES_PATH.LANDING, { replace: true });
    }

    return () => clearInterval(interval);
  }, [count]);

  return (
    <div className="flex flex-col gap-6 flex-1 p-6 h-[95%] overflow-auto">
      <div className="flex flex-col gap-2 justify-center items-center h-full">
        <img
          alt="tennis ball"
          src="/assets/icons/logo_black.svg"
          className="w-40 mb-3"
        />
        <Typography className="font-semibold !text-xl md:!text-2xl text-center">Your account is deleted</Typography>
        <Typography variant="subtitle1">Thank you for using GoodVets</Typography>
        <Typography variant="subtitle1" my={0.5} className="text-gray-1">
          You will be redirected in {count}...</Typography>
      </div>

    </div>
  );
};

export default UserDeleteModalRedirect;
